(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.ucwsThemeHeader = {
    isInitialized: false,
    attach: function attach(context) {
      if (this.isInitialized) {
        return;
      }
      this.isInitialized = true;

      //
      // Toolbox controls
      //
      var toolboxSpeed = 400;

      function openToolbox() {
        $('#toolbox .row.content').slideDown({
          duration: toolboxSpeed,
          start: function () {
            $('#toolbox .row.controls .btn').removeClass('btn-tab'); // Disable tab display
            $('#toolbox').addClass('toolbox-opening').addClass('toolbox-open');
          },
          complete: function () {
            $('#toolbox').removeClass('toolbox-opening');
          }
        });
      }

      function closeToolbox() {
        $('#toolbox .row.content').slideUp({
          duration: toolboxSpeed,
          start: function () {
            $('#toolbox .row.controls .btn').addClass('btn-tab'); // Enable tab display
            $('#toolbox').addClass('toolbox-opening').removeClass('toolbox-open');
          },
          complete: function () {
            $('#toolbox').removeClass('toolbox-opening');
          }
        });
      }

      // General toolbox display toggle
      $('#toolbox button.btn.btn-rounded').on('click', function () {
        $('#toolbox').hasClass('toolbox-open') ? closeToolbox() : openToolbox();
      });

      // Global search toolbox control
      $('#search-desktop input').on('focus', function () {
        openToolbox();
      });

      // Global search form submission
      $('#search-desktop, #search-mobile').on('submit', function () {
        closeToolbox();
      });

      //
      // Special scroll handling menus
      //
      if ($('#navigation')) {

        // Initial page load position (i.e. refresh @ bottom)
        var prevScrollTop = $(this).scrollTop();
        // Account for admin adjustments if logged in (doesn't
        // account for any offset changes on window resize)
        var origHeaderTop = parseFloat($('header').css('top'));

        $(window).on("scroll", function () {
          // Need this in scroll event in case they open the Toolbox etc.
          var dropShadowWidth = 15; // Also account for header's drop-shadow.
          var siteAlertHeight = ($('#global-alert').height() === undefined) ? 0 : $('#global-alert').height();
          var headerHideHeight = (siteAlertHeight + $('#toolbox').height() + $('#navigation').height() + dropShadowWidth);
          var minTop = origHeaderTop - headerHideHeight;
          var maxTop = origHeaderTop;

          // Gather current state values
          // Mobile devices can provide negative scroll positions!
          var vertScrollTop = ($(this).scrollTop() < 0) ? 0 : $(this).scrollTop();
          var currHeaderTop = parseFloat($('header').css('top'));

          var yTop, newTop;
          if (vertScrollTop > prevScrollTop) { // Scrolling down page
            newTop = currHeaderTop - (vertScrollTop - prevScrollTop);
            yTop = (newTop >= minTop) ? newTop : minTop;
          }
          else { // Scrolling up page
            newTop = currHeaderTop + (prevScrollTop - vertScrollTop);
            yTop = (newTop <= maxTop) ? newTop : maxTop;
          }
          prevScrollTop = vertScrollTop;

          $('header').css({'top': yTop});

          // Add class only when navigation is in 'pinned' position
          $('#navigation').toggleClass('pinned', yTop === minTop);
        });
      }
    }
  };
})(jQuery, Drupal);
